import ConsistencyTooltip from './ConsistencyTooltip';

export default ConsistencyTooltip;
